<template>
	<div v-if="visible" class="forward-select-overlay" @click.self="handleClose">
		<div class="forward-select-dialog" @click.stop>
			<div class="forward-select-header">
				<div class="forward-select-title">选择好友</div>
				<div class="forward-select-close el-icon-close" @click="handleClose"></div>
			</div>
			<div class="forward-select">
				<el-input class="search-text" size="small" placeholder="搜索好友" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
				<el-scrollbar class="friend-list" style="height: 400px;">
					<div v-if="filteredFriendValues.length === 0" style="text-align: center; padding: 20px; color: #999;">
						暂无好友
					</div>
					<div v-for="(friends, i) in filteredFriendValues" :key="i">
						<div class="letter">{{ filteredFriendKeys[i] }}</div>
						<div v-for="(friend) in friends" :key="friend.id" class="friend-item" @click="selectFriend(friend)">
							<friend-item :friend="friend" :active="false"></friend-item>
						</div>
						<div v-if="i < filteredFriendValues.length - 1" class="divider"></div>
					</div>
				</el-scrollbar>
			</div>
		</div>
	</div>
</template>

<script>
import FriendItem from "./FriendItem.vue";
import { pinyin } from 'pinyin-pro';
import { MESSAGE_TYPE } from "../../api/enums";

export default {
	name: "forwardSelect",
	components: {
		FriendItem
	},
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		forwardMsg: {
			type: Object,
			default: () => ({})
		},
		forwardBatch: {
			type: Object,
			default: null
		}
	},
	data() {
		return {
			searchText: ""
		}
	},
	computed: {
		filteredFriendGroups() {
			if (!this.friendStore || !this.friendStore.friends) {
				return [];
			}
			if (!this.searchText) {
				return this.friendKeys.map((key, index) => ({
					key,
					friends: this.friendValues[index]
				}));
			}
			const keyword = this.searchText.toLowerCase();
			return this.friendKeys.map((key, index) => ({
				key,
				friends: this.friendValues[index].filter(friend =>
					(friend.nickName || '').toLowerCase().includes(keyword)
				)
			})).filter(group => group.friends.length > 0);
		},
		filteredFriendValues() {
			return this.filteredFriendGroups.map(group => group.friends);
		},
		filteredFriendKeys() {
			return this.filteredFriendGroups.map(group => group.key);
		},
		friendGroupMap() {
			if (!this.friendStore || !this.friendStore.friends) {
				return new Map();
			}
			let groupMap = new Map();
			this.friendStore.friends.forEach((f) => {
				if (f.deleted) return;
				let letter = this.firstLetter(f.nickName).toUpperCase();
				if (!this.isEnglish(letter)) letter = "#";
				if (f.online) letter = '*';
				if (groupMap.has(letter)) {
					groupMap.get(letter).push(f);
				} else {
					groupMap.set(letter, [f]);
				}
			});
			let arrayObj = Array.from(groupMap);
			arrayObj.sort((a, b) => {
				if (a[0] == '#' || b[0] == '#') return b[0].localeCompare(a[0]);
				return a[0].localeCompare(b[0]);
			});
			groupMap = new Map(arrayObj.map(i => [i[0], i[1]]));
			return groupMap;
		},
		friendKeys() {
			return Array.from(this.friendGroupMap.keys());
		},
		friendValues() {
			return Array.from(this.friendGroupMap.values());
		}
	},
	methods: {
		handleClose() {
			this.$emit('close');
		},
		hasForwardMessage() {
			return !!this.forwardMsg && this.forwardMsg.type !== undefined && this.forwardMsg.type !== null;
		},
		selectFriend(friend) {
			const count = this.forwardBatch && this.forwardBatch.messages ? this.forwardBatch.messages.length : 1;
			const text = count > 1 ? `确定将选中的${count}条消息转发给【${friend.nickName}】？` : `确定将消息转发给【${friend.nickName}】？`;
			this.$confirm(text, '确认转发', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'info'
			}).then(() => {
				this.forwardMessage(friend);
			});
		},
		forwardMessage(friend) {
			if (this.forwardBatch && Array.isArray(this.forwardBatch.messages) && this.forwardBatch.messages.length) {
				this.forwardBatchMessages(friend);
				return;
			}
			// 如果 forwardMsg 为空，说明当前是“发送名片”模式，而不是转发已有消息
			if (!this.hasForwardMessage()) {
				// 交给父组件 ChatBox 的 onFriendPicked 逻辑去构造名片内容并发送
				this.$emit('friendPicked', friend);
				this.handleClose();
				return;
			}

			// 以下是“转发已有消息”的逻辑
			let content = this.forwardMsg.content;
			let messageType = this.forwardMsg.type;
			
			console.log('原始消息:', this.forwardMsg);
			console.log('原始消息类型:', this.forwardMsg.type);
			console.log('原始消息内容:', this.forwardMsg.content);
			
			if (this.forwardMsg.type === 1) { // 图片
				content = this.forwardMsg.content; // 保持原始JSON字符串
				messageType = 1;
			} else if (this.forwardMsg.type === 2) { // 文件
				content = this.forwardMsg.content;
		        messageType = 2;
				console.log('转发文件 - 保持的content:', content);
				console.log('转发文件 - 保持的messageType:', messageType);
			} else if (this.forwardMsg.type === 3) { // 语音
				content = this.forwardMsg.content;
		        messageType = 3;
			}
			
			console.log('转发消息:', {
				to: friend.nickName,
				content: content,
				type: messageType,
				originalMsg: this.forwardMsg
			});
			
			// 发送转发消息
			this.$http({
				url: '/message/private/send',
				method: 'POST',
				data: {
					recvId: friend.id,
					content: content,
					type: messageType
				}
			}).then((sentMessage) => {
				console.log('转发成功，服务器响应:', sentMessage);
				this.$message.success('转发成功');
				this.$emit('batchForwarded', {
					friend,
					messages: [sentMessage]
				});
				this.handleClose();
			}).catch((err) => {
				console.error('转发失败:', err);
				this.$message.error('转发失败');
			});
		},
		forwardBatchMessages(friend) {
			const messages = this.forwardBatch.mode === 'merged'
				? [{
					content: this.forwardBatch.mergedContent || this.buildMergedForwardMessage(),
					type: MESSAGE_TYPE.MERGED_FORWARD
				}]
				: this.forwardBatch.messages;
			Promise.all(messages.map((msg) => this.$http({
				url: '/message/private/send',
				method: 'POST',
				data: {
					recvId: friend.id,
					content: msg.content,
					type: msg.type
				}
			}))).then((sentMessages) => {
				this.$message.success('转发成功');
				this.$emit('batchForwarded', {
					friend,
					messages: sentMessages
				});
				this.handleClose();
			}).catch((err) => {
				console.error('批量转发失败:', err);
				this.$message.error('转发失败');
			});
		},
		buildMergedForwardMessage() {
			const records = (this.forwardBatch.messages || []).map(msg => ({
				sendNickName: msg.sendNickName,
				sendTime: msg.sendTime,
				type: msg.type,
				content: msg.content,
				text: msg.text
			}));
			return JSON.stringify({
				title: '聊天记录',
				summaryLines: records.slice(0, 4).map(record => `${record.sendNickName || '未知用户'}: ${record.text || '[消息]'}`),
				records
			});
		},
		firstLetter(strText) {
			let pinyinOptions = { toneType: 'none', type: 'normal' };
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0];
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	mounted() {
		// 组件已挂载
	},
	watch: {
		visible(newVal) {
			// 对话框显示状态变化
		}
	}
}
</script>

<style scoped lang="scss">
.forward-select {
	background: #fff;
	border-radius: 8px;

	.search-text {
		margin-bottom: 20px;
	}
	
	.friend-list {
		.letter {
			padding: 8px 16px;
			font-size: 12px;
			color: #999;
			background-color: #f5f5f5;
		}
		
		.friend-item {
			cursor: pointer;
			
			&:hover {
				background-color: #f0f0f0;
			}
		}
		
		.divider {
			height: 1px;
			background-color: #e0e0e0;
			margin: 8px 0;
		}
	}
}

.forward-select-overlay {
	position: absolute;
	inset: 0;
	z-index: 9998;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 24px;
	box-sizing: border-box;
	background: rgba(17, 24, 39, 0.24);
}

.forward-select-dialog {
	width: min(600px, calc(100% - 48px));
	max-width: 100%;
	background: #fff;
	border-radius: 8px;
	box-shadow: 0 12px 32px rgba(15, 23, 42, 0.18);
	overflow: hidden;
}

.forward-select-header {
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 64px;
	padding: 0 24px;
	border-bottom: 1px solid #ebeef5;
	box-sizing: border-box;
}

.forward-select-title {
	font-size: 18px;
	font-weight: 600;
	color: #111827;
}

.forward-select-close {
	position: absolute;
	right: 20px;
	top: 50%;
	transform: translateY(-50%);
	font-size: 22px;
	color: #9ca3af;
	cursor: pointer;
}

.forward-select-close:hover {
	color: #6b7280;
}

.forward-select-dialog .forward-select {
	padding: 20px 24px 24px;
	box-sizing: border-box;
}
</style> 
